import React, { useState } from "react";
import "./Services.css";
import Dialog from "@mui/material/Dialog";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";

const Services = () => {
  const [open, setOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState("");

  const services = [
    "Asesoramiento en la valoración y adquisiciones de bienes inmuebles.",
    "Estudios de viabilidad de proyectos.",
    "Diseño conceptual de proyectos arquitectónicos.",
    "Gestión de licencias, permisos y trámites de subvenciones.",
    "Diseño de espacios urbanos.",
    "Redacción de proyectos técnicos de reforma interior de espacios, restauración o rehabilitación integral de edificios.",
    "Lotizaciones y habilitaciones urbanas.",
    "Remodelación y diseño de casas.",
    "Diseño y remodelación de edificios multifamiliares.",
  ];

  const serviceCards = [
    {
      id: 1,
      name: "Diseño conceptual de proyectos arquitectónicos",
      image: "/img/diseno_conceptual.jpg",
    },
    {
      id: 2,
      name: "Diseño de interiores",
      image: "/img/remodelacion_casas.jpg",
    },
    {
      id: 3,
      name: "Diseño y remodelación de edificios multifamiliares",
      image: "/img/msgroup_diseno_edificios_multifamiliares.jpg",
    },
    {
      id: 4,
      name: "Lotizaciones y habilitaciones urbanas",
      image: "/img/lotizaion2.0.jpeg",
    },
  ];

  const handleOpen = (image) => {
    setSelectedImage(image);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedImage("");
  };

  return (
    <section id="services" className="services">
      <h1>Servicios</h1>

      <ul className="service-list">
        {services.map((service, index) => (
          <li key={index}>{service}</li>
        ))}
      </ul>

      <h2 className="projects-title">Proyectos destacados</h2>

      <div className="projects-carousel-wrapper">
        <Swiper
          modules={[Autoplay]}
          spaceBetween={24}
          slidesPerView={3}
          loop={true}
          autoplay={{
            delay: 3000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
          }}
          breakpoints={{
            0: { slidesPerView: 1 },
            768: { slidesPerView: 2 },
            1024: { slidesPerView: 3 },
          }}
          className="projects-swiper"
        >
          {serviceCards.map((service) => (
            <SwiperSlide key={service.id}>
              <div
                className="service-card"
                onClick={() => handleOpen(service.image)}
              >
                <img
                  src={service.image}
                  alt={service.name}
                  className="service-image"
                />
                <h3>{service.name}</h3>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>

      <Dialog open={open} onClose={handleClose} maxWidth="md">
        <div className="dialog-content">
          <IconButton
            onClick={handleClose}
            style={{ position: "absolute", right: 10, top: 10, zIndex: 2 }}
          >
            <CloseIcon />
          </IconButton>
          <img src={selectedImage} alt="Servicio" className="dialog-image" />
        </div>
      </Dialog>

      <div className="video-grid">
        <video
          className="video-item"
          autoPlay
          muted
          loop
          playsInline
          preload="metadata"
        >
          <source src="/video/construction.mp4" type="video/mp4" />
          Tu navegador no soporta reproducción de video.
        </video>

        <video
          className="video-item"
          autoPlay
          muted
          loop
          playsInline
          preload="metadata"
        >
          <source src="/video/VIVIENDA_FINAL.mp4" type="video/mp4" />
          Tu navegador no soporta reproducción de video.
        </video>
      </div>
    </section>
  );
};

export default Services;